import React, { forwardRef, useCallback, useImperativeHandle, useRef } from "react";
import { Box, Button, Card } from "@curves/ui-base";
import { Grid } from "@mui/material";
import { refIsRequiredError, isEmpty } from "@util/utils";
import { PAYMENT_TYPE } from "@icoach/constants/";
import CreditCard from "@icoach/components/creditCard/CreditCard";
import useDefaultCreditCard from "@util/hook/useDefaultCreditCard";

const PaymentSection = forwardRef((props, ref) => {
	const { memberID, initialSource = {}, errorModule, isSelected } = props;

	// 使用 Hook 管理付款常用信用卡
	const { formData, applyDefaultCreditCard } = useDefaultCreditCard(memberID, initialSource);

	const paymentCreditCardRef = useRef(null);

	// 處理付款錯誤資料
	const getPaymentError = useCallback(module => {
		const { payment, cardSignImg } = module || {};
		let paymentError = isEmpty(payment) ? {} : { ...payment };

		if (cardSignImg) {
			paymentError = {
				...paymentError,
				signImg: cardSignImg,
			};
		}

		return isEmpty(paymentError) ? null : paymentError;
	}, []);

	const getResult = useCallback(
		() => {
			let result = {
				paymentType: PAYMENT_TYPE.CREDITCARD,
			};

			if (paymentCreditCardRef.current && paymentCreditCardRef.current.getResult) {
				const creditData = paymentCreditCardRef.current.getResult();
				if (!isEmpty(creditData)) {
					const { signImg, ...other } = creditData;
					result.payment = other;
					result.paymentSignImg = signImg;
				}
			}

			return result;
		},
		// eslint-disable-next-line
		[]
	);

	useImperativeHandle(
		ref,
		() => ({
			getResult,
			isError: () => {
				const refsToCheck = [paymentCreditCardRef];
				return refIsRequiredError(...refsToCheck);
			},
		}),
		// eslint-disable-next-line
		[getResult]
	);

	// 如果沒有傳入 isSelected，預設為 true
	const shouldShow = isSelected !== undefined ? isSelected : true;

	return (
		<>
			<Card.CardHeader title="付款資訊" className="bg-light-active px-4 text-center" />
			{shouldShow && (
				<Card.CardContent key={formData.key} className="p-4">
					<Grid spacing={2} container>
						<Grid xs={12} item>
							<Box className="tool-btn-group">
								<Button color="gray" onClick={applyDefaultCreditCard}>
									套用常用信用卡
								</Button>
							</Box>
						</Grid>
						<Grid xs={12} item>
							{/* 補:發卡銀行資訊 */}
							<CreditCard ref={paymentCreditCardRef} defaultValue={formData.source} errorModule={getPaymentError(errorModule)} showSignature showCardRelation showBankName required />
						</Grid>
					</Grid>
				</Card.CardContent>
			)}
		</>
	);
});

PaymentSection.displayName = "PaymentSection";

export default PaymentSection;
